<template>
  <div>
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Reportes Sponsor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
        </div>
      </div>
      
    </base-header>

    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" >
            <div class="form-row">
                <div class="col-md-6" > 
                    <base-input label="Sponsor:" v-model="inputs.sponsor">
                        <el-select  v-model="inputs.sponsor"
                                    placeholder="Seleccione un sponsor..."
                        >
                            <el-option ref="selectSponsor" v-for="option in selectSponsors"
                                        :key="option.label"
                                        :label="option.label"
                                        :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Rango de fechas:" v-model="inputs.rango">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="configRango"
                                    class="form-control datepicker"
                                    v-model="inputs.rango">
                        </flat-picker>
                    </base-input>
                </div>
            </div>
        </card>
      </div>
    </div>
    
    <div class="container-fluid" v-if="showResults">
      <div class="card-deck flex-column flex-xl-row">
        <card>
            <div slot="header" class="row align-items-center">
                <div class="col">
                    <h6 class="text-uppercase text-muted ls-1 mb-1">Reportes Sponsor {{$refs.selectSponsor[0].$el.innerText}}</h6>
                    <h5 class="h3 mb-0">Ventas finalizadas por sucursal</h5>
                </div>
            </div>
            <!--
            <line-chart
                :height="350"
                ref="bigChart"
                :chart-data="bigLineChart.chartData"
                :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>
            -->
            
            <div class="row">
              <div class="col-md-12">
                <pie-chart
                    :height="800"
                    :chart-data="dataChart"
                    :extra-options="pieChart.extraOptions"
                >
                </pie-chart>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                  <div class="card bg-gradient-info border-0">
                    <!-- Card body -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ventas Terminadas</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">{{data.terminado}}/{{data.total_ventas}}</span>
                          <base-progress class="progress-xs mt-3 mb-0" type="success" :value="(data.terminado*100)/data.total_ventas"></base-progress>
                        </div>
                        <div class="col-auto">
                          <!--
                          <base-dropdown title-classes="btn btn-sm btn-neutral mr-0"
                                        menu-on-right
                                        :has-toggle="false">
                            <template slot="title">
                              <i class="fas fa-ellipsis-h"></i>
                            </template>
                            <a class="dropdown-item" href="#">Action</a>
                            <a class="dropdown-item" href="#">Another action</a>
                            <a class="dropdown-item" href="#">Something else here</a>
                          </base-dropdown>
                          -->
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <!--
                  <div class="card bg-gradient-danger border-0">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ventas anuladas</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">{{data.anulado}}/{{data.total_ventas}}</span>
                          <base-progress class="progress-xs mt-3 mb-0" type="success" :value="(data.anulado*100)/data.total_ventas"></base-progress>
                        </div>
                        <div class="col-auto">
                          -->
                          <!--
                          <base-dropdown title-classes="btn btn-sm btn-neutral mr-0"
                                        menu-on-right
                                        :has-toggle="false">

                            <template slot="title">
                              <i class="fas fa-ellipsis-h"></i>
                            </template>

                            <a class="dropdown-item" href="#">Action</a>
                            <a class="dropdown-item" href="#">Another action</a>
                            <a class="dropdown-item" href="#">Something else here</a>
                          </base-dropdown>
                          -->
                          <!--
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  -->
                  <div class="card bg-gradient-default border-0">
                    <!-- Card body -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ventas pendientes de pago</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">{{data.pendiente_pago}}/{{data.total_ventas}}</span>
                          <base-progress class="progress-xs mt-3 mb-0" type="success" :value="(data.pendiente_pago*100)/data.total_ventas"></base-progress>
                        </div>
                        <div class="col-auto">
                          <!--
                          <base-dropdown title-classes="btn btn-sm btn-neutral mr-0"
                                        menu-on-right
                                        :has-toggle="false">

                            <template slot="title">
                              <i class="fas fa-ellipsis-h"></i>
                            </template>

                            <a class="dropdown-item" href="#">Action</a>
                            <a class="dropdown-item" href="#">Another action</a>
                            <a class="dropdown-item" href="#">Something else here</a>
                          </base-dropdown>
                          -->
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <div class="card bg-gradient-warning border-0">
                    <!-- Card body -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ventas pendiente de firma</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">{{data.pendiente_firma}}/{{data.total_ventas}}</span>
                          <base-progress class="progress-xs mt-3 mb-0" type="success" :value="(data.pendiente_firma*100)/data.total_ventas"></base-progress>
                        </div>
                        <div class="col-auto">
                          <!--
                          <base-dropdown title-classes="btn btn-sm btn-neutral mr-0"
                                        menu-on-right
                                        :has-toggle="false">

                            <template slot="title">
                              <i class="fas fa-ellipsis-h"></i>
                            </template>

                            <a class="dropdown-item" href="#">Action</a>
                            <a class="dropdown-item" href="#">Another action</a>
                            <a class="dropdown-item" href="#">Something else here</a>
                          </base-dropdown>
                          -->
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <div class="card bg-gradient-primary border-0">
                    <!-- Card body -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ventas pendiente de confirmación</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">{{data.pendiente_confirmacion}}/{{data.total_ventas}}</span>
                          <base-progress class="progress-xs mt-3 mb-0" type="success" :value="(data.pendiente_confirmacion*100)/data.total_ventas"></base-progress>
                        </div>
                        <div class="col-auto">
                          <!--
                          <base-dropdown title-classes="btn btn-sm btn-neutral mr-0"
                                        menu-on-right
                                        :has-toggle="false">

                            <template slot="title">
                              <i class="fas fa-ellipsis-h"></i>
                            </template>

                            <a class="dropdown-item" href="#">Action</a>
                            <a class="dropdown-item" href="#">Another action</a>
                            <a class="dropdown-item" href="#">Something else here</a>
                          </base-dropdown>
                          -->
                        </div>
                      </div>
                      
                    </div>
                  </div>
              </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>

                  <div class="d-flex align-items-center">
                    <base-button
                      class="mr-2"
                      type="success"
                      size="sm"
                      icon
                      @click="generateExcel()"  
                    >
                    <i class="fa fa-file"></i> Descargar Excel
                    </base-button>
                    <base-input v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                placeholder="Buscar...">
                    </base-input>
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 table-responsive">
                  <el-table :data="queriedData"
                            row-key="id"
                            class="table-responsive table"
                            header-row-class-name="thead-light"
                            :default-sort = "{prop: 'monto', order: 'descending'}"
                            @selection-change="selectionChange">
                    <el-table-column
                      prop="id"
                      label="ID"
                      sortable
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="sucursal"
                      label="Sucursal"
                      sortable
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="planes vendidos"
                      label="Planes vendidos"
                      sortable
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="monto"
                      label="Monto"
                      sortable
                      width="180">
                      <div slot-scope="{$index, row}" class="d-flex">
                        {{parseFloat(row.monto).toFixed(2)}}
                      </div>
                    </el-table-column>
                    <el-table-column min-width="250px" align="right" label="Detalles">
                      <div slot-scope="{$index, row}" class="d-flex">
                        <base-button
                          type="primary"
                          size="sm"
                          icon
                          @click="openModalDetalles(row)"  
                        >
                        <i class="ni ni-fat-add"></i>  Ver detalles
                        </base-button>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <div class="">
                  <p class="card-category">
                    Mostrando desde {{ from + 1 }} al {{ to }} de un total de {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{selectedRows.length}} registros seleccionados
                    </span>
                  </p>
                </div>
                <base-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="total"
                >
                </base-pagination>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-12">
                <div class="card-body">
                    <h3 class="card-title mb-3">Total Sponsor :</h3>
                    <p class="card-text mb-4">$ {{ data.monto_total  }}</p>
                </div> 
              </div>
            </div>

            
        </card>
      </div>
    </div>
    <modal-ventas-sucursal></modal-ventas-sucursal>
  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';
  import PieChart from '@/components/Charts/PieChart';
  // Components
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  // Lists
  import ActivityFeed from '@/views/Dashboard/ActivityFeed';
  import TaskList from '@/views/Dashboard/TaskList';
  import UserList from '@/views/Dashboard/UserList';
  import ProgressTrackList from '@/views/Dashboard/ProgressTrackList';

  // Tables
  import LightTable from '@/views/Dashboard/LightTable';
  import SocialTrafficTable from '@/views/Dashboard/SocialTrafficTable';
  import PageVisitsTable from '@/views/Dashboard/PageVisitsTable';

  import { Select, Option } from 'element-ui';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  const Spanish = require("flatpickr/dist/l10n/es.js").default.es;
  import { Charts } from "@/components/Charts/config";
  function randomScalingFactor() {
    return Math.round(Math.random() * 100);
  }
  import Fuse from 'fuse.js';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
  import { BasePagination } from '@/components';
  import { Table, TableColumn} from 'element-ui';
  import ModalVentasSucursal from '@/views/Reportes/ModalVentasSucursal';

  export default {
    mixins: [clientPaginationMixin],
    components: {
      BasePagination,
      ActivityFeed,
      LineChart,
      BarChart,
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      TaskList,
      PageVisitsTable,
      SocialTrafficTable,
      LightTable,
      UserList,
      ProgressTrackList,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PieChart,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      ModalVentasSucursal
    },
    data() {
      return {
        bigLineChart: {
          allData: [
            [0, 20, 10, 30, 15, 40, 20, 60, 60],
            [0, 20, 5, 25, 10, 30, 15, 40, 40]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [
              {
                label: 'Performance',
                data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
              }
            ],
            labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }]
          },
          extraOptions: chartConfigs.blueChartOptions
        },
        selectSponsors: [],
        sponsor: undefined,
        dates: {
            range: undefined
        },
        configRango: {
            locale: Spanish,
            allowInput: false, 
            mode: 'range', 
            dateFormat: 'd-m-Y'
        },
        inputs: {
            sponsor: undefined,
            rango: '',
        },
        data: {},
        pieChart: {
          chartData: {
            labels: [
              'Danger',
              'Warning',
              'Success',
              'Primary',
              'Info'
            ],
            datasets: [{
              data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
              ],
              
              label: 'Dataset 1'
            }],
          },
          extraOptions: {
            responsive: true,
            legend: {
              "display": true,
              "fullWidth": true,
              "position": "bottom"
            },
            animation: {
              animateScale: true,
              animateRotate: true
            }
          }
        },
        dataChart: undefined,
        showResults: false,
        tableData: [],
        selectedRows: [],
        tableColumns: [],
        propsToSearch: ['sucursal'],
        
      };
    },
    methods: {
      initBigChart(index) {
        let chartData = {
          datasets: [
            {
              label: 'Performance',
              data: this.bigLineChart.allData[index]
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      fetchData()
      {
          var vm = this;
          vm.axios({
              url: 'api/reportes/sponsors_list',
              method: 'GET',
          }).then( response => {
              vm.selectSponsors = response.data;
          }).catch( error => {
              console.log(error);
          });
      },
      selectionChange(selectedRows) {
        this.selectedRows = selectedRows
      },
      openModalDetalles(row)
      {
        console.log('row',row);
        const encontrado = this.data.sucursales.find(e => e.id == row.id);
        if(encontrado){
          this.$emit('openModalVentasSucursal', { sucursal: encontrado, extras: this.inputs.rango } );
        }
        
      },
      generateExcel(){
        console.log(this.tableData);
        if(!this.tableData.length) return;
        var vm = this;
        var headers = ["Sponsor","Sucursal","Planes vendidos","Monto",];
        var mapeado = this.tableData.map(e => ([
            this.selectSponsors.find(element => element.value == this.inputs.sponsor).label,
            e.sucursal,
            e["planes vendidos"],
            e.monto
        ]))
        this.axios({
            url: 'api/excel/from_array',
            method: 'POST',
            data: {
                data: mapeado,
                cabeceras: headers
            },
            responseType: 'blob',
        }).then( response => {
            const newBlob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"})
            const data = window.URL.createObjectURL(newBlob);
            window.open(data, "_blank");
        }).catch( error => {
            console.log(error);
        });
      }
    },
    mounted() {
      this.initBigChart(0);
      this.fetchData();
    },
    watch: {
        inputs: {
            deep: true,
            handler(){
                if( this.inputs.rango.includes(' a ') && this.inputs.sponsor ){
                    var vm = this;
                    this.axios({
                        url: 'api/reportes/sponsor_ventas',
                        method: 'POST',
                        data: {
                            sponsor: this.inputs.sponsor,
                            range: this.inputs.rango.split(" a ")
                        }
                    }).then( response => {
                        this.data = response.data;
                        if( response.data.total_ventas )
                        {
                          this.dataChart = {
                            labels : response.data.sucursales.map( e => e.name),
                            datasets : [
                              {
                                  data : response.data.sucursales.map(e => e.planes_vendidos),
                                  backgroundColor : response.data.sucursales.map(e => e.planes_vendidos).map(e => 
                                  'rgba('+(Math.floor(Math.random() * 250) + 1 ).toString()+','+(Math.floor(Math.random() * 250) + 1 ).toString()+','+(Math.floor(Math.random() * 250) + 1 ).toString()+','+(Math.floor(Math.random() * 250) + 1 ).toString()+')') ,
                                  borderColor : response.data.sucursales.map(e => e.planes_vendidos).map(e => 'rgba(136,136,136,0.5)'),
                                  label:"sucursales"
                              },
                            ]
                          };
                          
                          let dataFormateada = response.data.sucursales.map(e => ({ id: e.id, sucursal: e.name, "planes vendidos": e.planes_vendidos, monto: e.monto }));
                          
                          let columnas;
                          if( dataFormateada.length > 0 ) columnas = Object.getOwnPropertyNames(dataFormateada[0]);
                          
                          vm.tableData = dataFormateada.sort((a,b) => b.monto-a.monto);
                          vm.tableColumns = [];
                          vm.tableColumns.push({ type: 'selection' });
                          columnas.forEach( item => {
                            vm.tableColumns.push({ prop: item, label: item, sortable: true });
                          } );
                          vm.fuseSearch = new Fuse(vm.tableData, {
                            keys: this.propsToSearch,
                            threshold: 0.3
                          });
                          this.showResults = true;
                        }else {
                          this.$notify({
                            message: 'No se encontraron resultados en esta búsqueda',
                            type: 'default'
                          })
                        }
                    }).catch( error => {
                        this.showResults = false;
                        this.$notify({
                            message: 'Hubo un error con la búsqueda',
                            type: 'danger'
                        });
                    });
                }
            }
        }
    }
  };
</script>
<style></style>
